module.exports = __webpack_public_path__ + "static/media/bloodyClock.6c01aed3.jpg";